import React, {useEffect} from 'react';
import {Stack} from "@mui/material";
import Button from "@mui/material/Button";

function PlanningPage({dispatch, ...props}) {

    const gsheetUrl = "https://docs.google.com/spreadsheets/d/e/2PACX-1vTb6_gv2Mnhi1CpObnUXA_vNsni-fT0lPdf3M4lWTQ-cWuIWoByytECwDOHqbRMVV_G1GqSyzuUJVyJ/pubhtml?gid=581953458&single=true";

    return (
        <div style={{width: '100%', height: '85vh'}}>
            <Stack justifyContent="center" spacing={2} direction="row">
                <Button
                    sx={{width: "50%"}}
                    variant={"contained"}
                    onClick={() => {
                        window.open('https://docs.google.com/spreadsheets/d/1hHEtQPtjDa5ANTKCoO6Ev0VGA3a9Nr_TbRI-oG7YHvc/edit?gid=581953458#gid=581953458', '_blank')
                    }}>
                    Accéder au planning
                </Button>
            </Stack>
            <iframe
                title="Planning"
                src={gsheetUrl}
                style={{width: '100%', height: '100%', border: 'none'}}
            />
        </div>
    )
}

export default PlanningPage;
